module.exports = __webpack_public_path__ + "static/images/icon-mercedes.dd00f33fc1bac1a63432d769acf54286.svg";